<template>
    <div class="country-us" :class="$x.nsAddressForm">
        <VTextField
            v-model="address.address1"
            name="address1"
            maxlength="35"
            required
            validate-on-blur
            :label="t.address1Label"
            class="flex-column"
            :rules="address1Rules"
            @blur="onBlur"
            @input="addressUpdated"
        ></VTextField>
        <VTextField
            v-model="address.address2"
            class="flex-column"
            name="address2"
            maxlength="35"
            validate-on-blur
            :aria-label="t.address2Label"
            :rules="address2Rules"
            @blur="onBlur"
            @input="addressUpdated"
        >
            <template #label>
                {{ t.address2Label }}
                <span :class="$x.optional"> {{ t.optional }} </span>
            </template>
        </VTextField>
        <VTextField
            v-model="address.city"
            name="city"
            maxlength="25"
            required
            validate-on-blur
            :label="t.cityLabel"
            class="flex-column"
            :rules="cityRules"
            @input="addressUpdated"
            @blur="onBlur"
        ></VTextField>
        <div :class="$x.dualColumn">
            <NsSelect
                v-model="address.region"
                :items="regions"
                name="region"
                :class="$x.firstCol"
                class="flex-column"
                :rules="stateRules"
                :label="t.regionLabel"
                autocomplete="address-level1"
                @input="addressUpdated"
                @blur="onBlur"
            ></NsSelect>
            <VTextField
                v-model="address.postalCode"
                name="postalCode"
                maxlength="10"
                required
                validate-on-blur
                :label="t.postalCodeLabel"
                class="flex-column"
                :rules="postalCodeRules"
                @input="addressUpdated"
                @blur="onBlur"
            ></VTextField>
        </div>
        <VTextField
            v-if="includeEmail"
            v-model="address.email"
            name="email"
            maxlength="50"
            required
            validate-on-blur
            :label="t.emailLabel"
            class="flex-column"
            :rules="emailRules"
            @input="addressUpdated"
            @blur="onBlur"
        ></VTextField>
    </div>
</template>

<script>
import { VTextField } from 'vuetify/lib';
import {NsSelect} from '@nuskin/design-components';
// Do not delete these are used by the mixin
import ADDRESS_MIXIN from '../addressMixin.js';
import REGIONS from './regions.json';
import TRANSLATIONS from './translations.json';

export default {
    name: 'NsAddressUs',
    components: {
        VTextField,
        NsSelect,
    },
    mixins: [ADDRESS_MIXIN],
    data() {
        return {
            regions: REGIONS,
        };
    },
    mounted() {
        this.address.country = 'US';
        if (TRANSLATIONS[this.lang]) {
            this.t = TRANSLATIONS[this.lang];
        } else {
            // If the language isn't available then get the first language in translations file
            this.t = TRANSLATIONS[Object.keys(TRANSLATIONS)[0]];
        }
        this.$emit('new-address-in-form');
    },
    methods: {},
};
</script>

<style lang="scss" module="$x">
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";

$color-eeyore: map.get(colors.$baseColors, eyore);

.nsAddressForm {
  .dualColumn {
    display: flex;
    align-content: space-between;
    .firstCol {
      margin-right: 20px;
    }
  }
}

.optional {
  color: $color-eeyore;
}
</style>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";

*:not(.v-icon) {
  font-family: map.get(typographyVariables.$typography, 'font-family-primary');
}
</style>
